import {useLocalStorage} from '@aboutyou/storage';
import {STORAGE_SEARCHES_KEY} from './useStoredSearchTerms';

type DeprecatedStoredSearches = {
  terms: Array<string>;
};

export const useGetOldStoredSearchTerms = () => {
  return useLocalStorage<DeprecatedStoredSearches>({
    key: STORAGE_SEARCHES_KEY,
    defaultValue: {terms: []},
  });
};
